/**
 * The permission catalogue: every permission string that may be GRANTED to
 * a person, in one place.
 *
 * The API's grant endpoint rejects anything not listed here, and the web
 * client draws its checkboxes from the same list, so the two cannot drift.
 * Adding a permission is a change to this file - no schema change: grants
 * are rows in user_permissions (apps/api/sql/2026-09-28-user-permissions.sql).
 *
 * NOT listed here: the legacy strings 'people.manage' and 'task.create'.
 * The API still grants those to every signed-in user, exactly as before
 * (services/permission.service.ts). They are never stored and never shown.
 */
export const Permission = {
    /** See lottery data and download lottery reports. */
    LOTTERY_VIEW: 'lottery.view',
    /** Upload the daily lottery files. Only valid together with LOTTERY_VIEW. */
    LOTTERY_UPLOAD: 'lottery.upload',
};
/** Every grantable permission, in display order. */
export const GRANTABLE_PERMISSIONS = [
    Permission.LOTTERY_VIEW,
    Permission.LOTTERY_UPLOAD,
];
/**
 * Permission -> the permission it cannot exist without.
 *
 * Granting a key without its value is rejected; a key whose value is no
 * longer held is treated as not held (so revoking lottery.view also takes
 * lottery.upload away).
 */
export const PERMISSION_REQUIRES = {
    [Permission.LOTTERY_UPLOAD]: Permission.LOTTERY_VIEW,
};
//# sourceMappingURL=permissions.js.map